import gql from "graphql-tag";
import { QueryHookOptions, useQuery } from "@apollo/client";

import { TemplateFragment, TEMPLATE_FRAGMENT } from "../../fragments";
import { Collection, TemplatesQueryVariables } from "../../types";

export const GET_TEMPLATES = gql`
  query getTemplates($madId: ID) {
    templates(madId: $madId) {
      collection {
        ...TemplateFragment
      }
    }
  }
  ${TEMPLATE_FRAGMENT}
`;

export type TemplatesData = { templates: Collection<TemplateFragment> };

export default (
  options?: QueryHookOptions<TemplatesData, TemplatesQueryVariables>
) => {
  return useQuery<TemplatesData, TemplatesQueryVariables>(
    GET_TEMPLATES,
    options
  );
};
